'use strict';

import React from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import { connect } from 'react-redux';

import SlideSection from '../components/SlideSection';
import SlideNav from '../components/SlideNav';
import { toggleSlideLeave } from '../actions';

const getCount = items => {
  const group = { ...items };
  if (group.hasOwnProperty('settings')) {
    delete group.settings;
  }
  return Object.keys(group).length;
};

const ConnectedApp = ({ data, slideStatus }) => {
  const onLeaveHandler = (origin, destination, direction) => {
    const oIndex = origin.index;
    const dIndex = destination.index;

    if (direction == 'down') {
      // if origin false && destination false kill scroll
      if (!slideStatus[oIndex].completed && !slideStatus[dIndex].completed) {
        return false;
      } else {
        return true;
      }
    }
  };

  const totalSlides = getCount(data);

  return (
    <ReactFullpage
      licenseKey={'AE1E26D8-94674F4F-A845FB49-3C447815'}
      autoScroll={false}
      scrollOverflow={true}
      normalScrollElements={'.react-select__menu'}
      onLeave={onLeaveHandler}
      fixedElements={'.fullpage__nav-group'}
      render={({ state, fullpageApi }) => {
        return (
          <ReactFullpage.Wrapper>
            {Object.keys(data).map((key, index) => {
              if (key == 'settings') return null;

              const slide = data[key];
              return (
                <SlideSection
                  slideIndex={index}
                  fullpageApi={fullpageApi}
                  results_key={slide.results_key}
                  key={slide.id}
                  totalSlides={totalSlides}
                  type={slide.type}
                  title={slide.question}
                  image={slide.images.original}
                  options={slide.options}
                  description={slide.description}
                />
              );
            })}
            <SlideNav fullpageState={state} fullpageApi={fullpageApi} />
          </ReactFullpage.Wrapper>
        );
      }}
    />
  );
};

const mapStatetoProps = state => {
  const { sliderDisabled, slideStatus } = state;
  return {
    sliderDisabled: sliderDisabled,
    slideStatus: slideStatus,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSlideLeave: () => dispatch(toggleSlideLeave()),
  };
};

const CareerApp = connect(mapStatetoProps, mapDispatchToProps)(ConnectedApp);

export default CareerApp;
